import LocalImage from "@/components/image/LocalImage";

//#region [Props]
type CheckMarkProps = {
    className?: string;
    alt: string;
};
//#endregion

//#region [Component]
export default function CheckMark({ className, alt }: CheckMarkProps) {
    return <LocalImage className={className} src="/CheckMark.svg" alt={alt} width={17.678} height={17.678} />;
}
//#endregion
